import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import ProjectsAboutDefault from './Default/ProjectsAbout';
import ProjectsAboutPlayful from './Playful/ProjectsAbout';

export function ProjectsAbout(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <ProjectsAboutPlayful {...props} /> : <ProjectsAboutDefault {...props} />;
}
